// src/pages/LoginPage.js
import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './LoginPage.module.css';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(''); // Hata mesajı state'i
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Önceki hataları temizle
    setLoading(true);
    try {
      // login fonksiyonu artık başarılı olursa normal döner, başarısız olursa hata fırlatır.
      await login(username, password);

      // Eğer buraya kadar geldiyse (hata fırlatılmadıysa) giriş başarılıdır.
      navigate(from, { replace: true });

    } catch (err) {
      // login fonksiyonundan fırlatılan hatayı yakala
      setError(err.message || 'Giriş sırasında bilinmeyen bir hata oluştu.'); // Hata mesajını state'e ata
    } finally {
      // İşlem başarılı da olsa başarısız da olsa loading'i kapat
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      {/* Marka paneli — konsolun eşiği */}
      <aside className={styles.brandPanel}>
        <div className={styles.brandInner}>
          <div className={styles.signalMark} aria-hidden="true">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <p className={styles.brandKicker}>eSIM Operasyon Konsolu</p>
          <h1 className={styles.wordmark}>Utkan Mobile</h1>
          <p className={styles.brandCopy}>
            Siparişleri, paketleri ve bağlantıları tek panelden yönetin.
            Devam etmek için oturum açın.
          </p>
        </div>
      </aside>

      {/* Giriş paneli — hızlı ve net */}
      <main className={styles.formPanel}>
        <form onSubmit={handleSubmit} className={styles.loginForm}>
          <h2 className={styles.formTitle}>Oturum aç</h2>
          <p className={styles.formLead}>Hesap bilgilerinizle konsola girin.</p>

          {/* Hata state'i doluysa göster */}
          {error && <p className={styles.error} role="alert">{error}</p>}

          <div className={styles.formGroup}>
            <label htmlFor="username">Kullanıcı adı</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="password">Şifre</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <button type="submit" disabled={loading} className={styles.loginButton}>
            {loading ? 'Giriş yapılıyor…' : 'Giriş yap'}
          </button>
        </form>
      </main>
    </div>
  );
};

export default LoginPage;